import React from 'react';
import { Image } from 'react-konva';
import DisableImg from 'components/main/images/DisabledImaging.png';

const DisableImage = (props) => {
  const drawImage = () => {
    const imageObj = new window.Image();
    imageObj.src = DisableImg;
    return (
      <Image
        id='disableimage-img'
        x={props.x}
        y={props.y}
        image={imageObj}
        width={props.width}
        height={props.height}
      />
    );
  };

  return drawImage();
};
export default DisableImage;
